define('boxes/pending-withdraws-box',['jquery', 'all/paymentServices-toggles', 'boxes/helpers/message-popup', 'all/textKey', 'boxes/box', 'all/jquery/jquery.mustache',
	'boxes/helpers/box-loading'], function ($, paymentServicesToggles, messagePopup, textKey, box, mustache, boxLoading) {

    'use strict';

    function getPendingWithdrawalsUrl() {

		return paymentServicesToggles.useNewPaymentFormDataService()
			? '/PaymentFormDataService/getPendingWithdrawals' : '/pp?flow=GetPendingWithdrawals';
    }

    function showText(dataAttribute, $element) {
        var titleText = $element.data(dataAttribute);
        $element.text(titleText);
    }

    function yesButtonClickHandler(pendingWithdraws) {
        var $box = pendingWithdraws.$box,
            id = $box.find('.overlay').data('id'),
            texts = pendingWithdraws.model.texts;
		$.get('/PaymentFormDataService/cancelWithdraw?id=' + id, function (data) {
			if (data.status === 'SUCCESS') {
                var $removePendingWithdrawal = $box.find('.frame-row[data-withdrawal-id=' + id + ']');
                $removePendingWithdrawal.remove();
                $box.find('.overlay').remove();
            } else {
                $box.find('.overlay').remove();
                messagePopup.show($box, 'message-popup',{
                    title: texts.PENDING_WITHDRAWS_CANCEL_WITHDRAW_ERROR_TITLE,
                    message: texts.PENDING_WITHDRAWS_CANCEL_WITHDRAW_ERROR_MESSAGE,
                    closeButtonText: texts.PENDING_WITHDRAWS_CLOSE_BUTTON
                });
            }
            if ($box.find('.frame-row').length < 1 && pendingWithdraws.model.isProgressBox === false) {
                pendingWithdraws.$controller.nextBox();
            }
        });
    }

    function cancelButtonClickHandler(pendingWithdraws, event) {
        event.preventDefault();
        var $cancelButton = $(event.target),
            withdrawalId = $cancelButton.parent().data('withdrawal-id'),
            texts = pendingWithdraws.model.texts;
        messagePopup.show(pendingWithdraws.$box, 'message-popup',{
            data: withdrawalId,
            title: texts.PENDING_WITHDRAWS_CANCEL_WITHDRAW_TITLE,
            message: texts.PENDING_WITHDRAWS_CANCEL_WITHDRAW_MESSAGE,
            confirmButtonText: texts.PENDING_WITHDRAWS_YES_BUTTON,
            closeButtonText: texts.PENDING_WITHDRAWS_CLOSE_BUTTON
        }, {
            confirmButtonCallback: function (event) {
                event.preventDefault();
                yesButtonClickHandler(pendingWithdraws);
            }
        });
    }



    var HTML = {method: 'html'},
        view = {
            render: function (pendingWithdraws) {
                var mustacheTemplateName = 'pending-withdrawal-template',
                    $pendingWithdrawalsElement = pendingWithdraws.$box.find('.pending-withdraws');

                $pendingWithdrawalsElement.find('.frame-row').remove();

				var pendingWithdrawalsData = {};
				if (paymentServicesToggles.useNewPaymentFormDataService()) {
					pendingWithdrawalsData.pendingWithdrawals = pendingWithdraws.model.data;
				} else {
					pendingWithdrawalsData = pendingWithdraws.model.data;
				}

				if (pendingWithdrawalsData.pendingWithdrawals.length > 0) {
                    showText('regularText', pendingWithdraws.$box.find('h2'));
                    showText('regularText', pendingWithdraws.$box.find('p'));
                    $.Mustache.addFromDom(mustacheTemplateName);
                    $pendingWithdrawalsElement.mustache(mustacheTemplateName, pendingWithdrawalsData, HTML);
                } else {
                    showText('emptyText', pendingWithdraws.$box.find('h2'));
                    showText('emptyText', pendingWithdraws.$box.find('p'));
                }
            }
        },
        model = {
            data: {
                pendingWithdrawals: []
            },
            texts: {
                PENDING_WITHDRAWS_CANCEL_WITHDRAW_TITLE: 'Cancel Withdraw',
                PENDING_WITHDRAWS_CANCEL_WITHDRAW_MESSAGE: 'Do you really want to cancel?',
                PENDING_WITHDRAWS_YES_BUTTON: 'Yes, cancel this withdrawal',
                PENDING_WITHDRAWS_CLOSE_BUTTON: 'Close',
                PENDING_WITHDRAWS_CANCEL_WITHDRAW_ERROR_TITLE: 'Cancel Withdraw Error',
                PENDING_WITHDRAWS_CANCEL_WITHDRAW_ERROR_MESSAGE: 'It was not possible to delete the withdraw'
            },
            init: function (pendingWithdraws) {
                textKey.readTextValues(Object.keys(pendingWithdraws.model.texts), function (textValues) {
                    $.extend(pendingWithdraws.model.texts, textValues);
                });
                pendingWithdraws.$box.find('.next').data('');
            },
            isProgressBox: false,
            beforeRender: function (pendingWithdraws) {
                var ajaxPromise = box.ajax(pendingWithdraws, {
                    url: getPendingWithdrawalsUrl(),
                    data: { useDateFormat: true },
                    type: 'GET'
                }, function (data, ajaxPromise) {
					if (paymentServicesToggles.useNewPaymentFormDataService()) {

						if ((data.length < 1 && pendingWithdraws.model.isProgressBox) || data.length > 0) {
							pendingWithdraws.model.data = data;
							ajaxPromise.resolve();
						} else {
							pendingWithdraws.model.data = [];
							ajaxPromise.reject();
						}

					} else {

						if (data.RESULT === 'OK' &&
							((data.pendingWithdrawals.length < 1 && pendingWithdraws.model.isProgressBox) || data.pendingWithdrawals.length > 0)) {

							pendingWithdraws.model.data = data;
							ajaxPromise.resolve();
						} else {
							pendingWithdraws.model.data = [];
							ajaxPromise.reject();
						}

					}
                });
                return [ajaxPromise.promise()];
            },
            afterRender: function (pendingWithdraws) {
                var $nextButton = pendingWithdraws.$box.find('.next'),
                    $cancelButtons = pendingWithdraws.$box.find('.btn');
                if (pendingWithdraws.model.isProgressBox) {
                    $nextButton.hide();
                } else {
                    $nextButton.show();
                    $nextButton.off().on('click', function (event) {
                        event.preventDefault();
                        $(this).off().on('click', function(event){
                            // Doing nothing on the next click.
                            event.preventDefault();
                        });
                        boxLoading.showLoading(pendingWithdraws.$box);
                        pendingWithdraws.$controller.nextBox();
                    });
                }
                $cancelButtons.on('click', function (event) {
                    event.preventDefault();
                    cancelButtonClickHandler(pendingWithdraws, event);
                });
            }
        };

    return {
        create: function ($box, $controller, isProgressBox) {
            var newModel = $.extend({}, model);

            if (isProgressBox !== undefined && isProgressBox) {
                newModel.isProgressBox = isProgressBox;
            }
            return box.create($box, $controller, view, newModel);
        }
    };
});

